module.exports = __webpack_public_path__ + "img/Dai3-new-re.69bf2dc8.png";